import type { ForwardedRef } from 'react';

import { useImperativeHandle, useMemo } from 'react';

import type { AppHooks, AppProps, AppRef } from './_.type';

/**
 * Use App hooks.
 *
 * @param {AppProps} _props App props.
 * @param {AppRef} ref App ref.
 *
 * @returns {AppHooks} App hooks.
 */
export default function useAppHooks(_props: AppProps, ref: ForwardedRef<AppRef>): AppHooks {
  useImperativeHandle(ref, () => ({}));

  return useMemo<AppHooks>(
    () => ({
      refs: {},

      states: {},

      events: {},
    }),
    [],
  );
}
